import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Toolbar } from '@mui/material';
import { Question, QuestionActions } from '../../../components/Styled/Misc';
import { SaveButton, CloseButton } from '../../../components/Styled/Buttons';
import { actions } from './actions';
import RefreshButton from '../../../components/buttons/refresh';

export const catEditorCP = ({ onActionClick, isChanged }) => (
  <Paper sx={{ mb: 1 }}>
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton onClick={(e) => onActionClick(e, actions.save)} disabled={!isChanged} />
      <RefreshButton onClick={(e) => onActionClick(e, actions.reload)} disabled={isChanged} />
      {isChanged ? (
        <Question
          questionText="Вийти без запису?"
          actionHandler={(e, v) => {
            if (v === QuestionActions.YesNoAction.yes.value) {
              onActionClick(e, actions.close);
            }
            e.stopPropagation();
          }}
          actions={Object.values(QuestionActions.YesNoAction)}
        >
          <CloseButton onClick={(e) => onActionClick(e, actions.close)} />
        </Question>
      ) : (
        <CloseButton onClick={(e) => onActionClick(e, actions.close)} />
      )}
    </Toolbar>
  </Paper>
);

catEditorCP.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  isChanged: PropTypes.bool,
};

catEditorCP.defaultProps = {
  isChanged: false,
};

export default catEditorCP;
